import { render } from "./bank-choose.vue?vue&type=template&id=1d15a5f1&scoped=true"
import script from "./bank-choose.vue?vue&type=script&lang=js"
export * from "./bank-choose.vue?vue&type=script&lang=js"

import "./bank-choose.vue?vue&type=style&index=0&id=1d15a5f1&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d15a5f1"]])

export default __exports__